import i18next from 'i18next';

// this should only ever be called once -- see the i18next docs
// when calling this, specifiy resources and defaultNS like so:
// initialize( { resources: { ... }, defaultNS: 'namespace_here' })
export function initialize(options) {
  return i18next.init({
    lng: 'en',
    interpolation: {
      prefix: '{',
      suffix: '}'
    },
    ...options
  });
}
